export default "__VITE_ASSET__nNr3vtOy__"